
export default function (text, wordCount, mode) {
  mode = mode || 'word';
  if (mode === 'word') {
    text = text.split(' ');
    if (text.length > wordCount) {
      text = text.slice(0, wordCount);
      text = text.join(' ');
      text = text + '...';
    } else {
      text = text.join(' ');
    }
    return text;
  } else {
    if (text.length > wordCount) {
      text = text.slice(0, wordCount);
      text = text + '..';
    }
    return text;
  }
}